import I18n from '@/modules/i18n';
import Templates from '@/pages/site/templates';

import GridyIndex from '@/controllers/common/gridy_index_controller';

export default class extends GridyIndex {
  gridyOptions() {
    return {
      find: 'name',
      sortName: 'name',
      template: Templates.link_trees.gridy,

      headers: [
        { name: I18n.t('name'), value: 'name' },
        { name: I18n.t('description.one'), value: 'description' },
        { name: I18n.t('slug'), value: 'slug' },
        { name: I18n.t('action.other'), value: '' },
      ],
    };
  }
}
